<template>
  <svg
    v-if="starType === 'normal' && !isMobile"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon">
      <mask
        id="mask0_1674_2078"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect id="Bounding box" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1674_2078)">
        <path
          id="grade"
          d="M8.00017 11.5161L5.23351 13.1828C5.11128 13.2606 4.98351 13.2939 4.85017 13.2828C4.71684 13.2717 4.60017 13.2273 4.50017 13.1495C4.40017 13.0717 4.3224 12.9745 4.26684 12.8578C4.21128 12.7411 4.20017 12.6106 4.23351 12.4661L4.96684 9.31615L2.51684 7.19948C2.40573 7.09948 2.33628 6.98559 2.30851 6.85781C2.28073 6.73003 2.28906 6.60503 2.33351 6.48281C2.37795 6.36059 2.44462 6.26059 2.53351 6.18281C2.6224 6.10503 2.74462 6.05503 2.90017 6.03281L6.13351 5.74948L7.38351 2.78281C7.43906 2.64948 7.52517 2.54948 7.64184 2.48281C7.75851 2.41615 7.87795 2.38281 8.00017 2.38281C8.1224 2.38281 8.24184 2.41615 8.35851 2.48281C8.47517 2.54948 8.56128 2.64948 8.61684 2.78281L9.86684 5.74948L13.1002 6.03281C13.2557 6.05503 13.378 6.10503 13.4668 6.18281C13.5557 6.26059 13.6224 6.36059 13.6668 6.48281C13.7113 6.60503 13.7196 6.73003 13.6918 6.85781C13.6641 6.98559 13.5946 7.09948 13.4835 7.19948L11.0335 9.31615L11.7668 12.4661C11.8002 12.6106 11.7891 12.7411 11.7335 12.8578C11.678 12.9745 11.6002 13.0717 11.5002 13.1495C11.4002 13.2273 11.2835 13.2717 11.1502 13.2828C11.0168 13.2939 10.8891 13.2606 10.7668 13.1828L8.00017 11.5161Z"
          fill="#E6C200"
        />
      </g>
    </g>
  </svg>
  <svg
    v-else-if="starType === 'normal' && isMobile"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.10178 3.60558C6.94621 2.09075 7.36841 1.33333 7.99968 1.33333C8.63094 1.33333 9.05314 2.09074 9.89754 3.60558L10.116 3.99748C10.356 4.42795 10.4759 4.64319 10.6631 4.7852C10.8501 4.92722 11.0831 4.97993 11.5491 5.08536L11.9733 5.18135C13.6131 5.55237 14.433 5.73788 14.6281 6.36515C14.8231 6.9924 14.2642 7.64606 13.1463 8.95326L12.8571 9.29146C12.5394 9.66293 12.3805 9.84866 12.3091 10.0785C12.2377 10.3083 12.2617 10.5561 12.3097 11.0517L12.3534 11.5029C12.5224 13.2471 12.6069 14.1191 12.0963 14.5068C11.5855 14.8945 10.8179 14.541 9.28254 13.8341L8.88534 13.6512C8.44908 13.4503 8.23094 13.3499 7.99968 13.3499C7.76841 13.3499 7.55028 13.4503 7.11401 13.6512L6.71681 13.8341C5.18146 14.541 4.4138 14.8945 3.90311 14.5068C3.39242 14.1191 3.47693 13.2471 3.64594 11.5029L3.68966 11.0517C3.7377 10.5561 3.76171 10.3083 3.69025 10.0785C3.6188 9.84866 3.45996 9.66293 3.14229 9.29146L2.85308 8.95326C1.73518 7.64606 1.17622 6.9924 1.37129 6.36515C1.56636 5.73788 2.38625 5.55237 4.02604 5.18135L4.45027 5.08536C4.91624 4.97993 5.14923 4.92722 5.3363 4.7852C5.52338 4.64319 5.64336 4.42796 5.88332 3.99748L6.10178 3.60558Z"
      fill="#E6C200"
    />
  </svg>

  <svg
    v-if="starType === 'small'"
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.50033 0.666664L5.53032 2.75333L7.83366 3.09L6.16699 4.71333L6.56033 7.00666L4.50033 5.92333L2.44033 7.00666L2.83366 4.71333L1.16699 3.09L3.47033 2.75333L4.50033 0.666664Z"
      fill="#FFD700"
    />
  </svg>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    starType: {
      type: String,
      default: "normal",
    },
  },
  computed: {
    ...mapGetters(["isMobile"]),
  },
};
</script>
